import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppMessageService } from '../../services/app-message/app-message.service';
import { CoreSearchData, CoreSearchSettings, SearchService } from './services/search.service';
import { SearchSettingsComponent } from './search-settings/search-settings.component';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {

  @ViewChild('searchSettings') configPanel: SearchSettingsComponent;
  @ViewChild('searchBar', {read: ElementRef}) searchBar: ElementRef;
  
  settings: CoreSearchSettings = this.searchService.getDefaulthSettings();

  dialogOpen: boolean = false;
  pinnedOpen: boolean = false;
  openConfig: boolean = false;
  searchText: string = '';

  isProcessing = false;
  datas: CoreSearchData[] = [];

  pinnedItems: CoreSearchData[] = [];
  private readonly search$ = new Subject<string>();

  componentLoaded: boolean = false;
  private searchSubscription: Subscription;

  constructor(
    private readonly searchService: SearchService,
    private readonly mesage: AppMessageService) {}

  ngOnInit(): void {
    this.settings = this.searchService.loadSettingsFromStorage();
    this.addCustomSearchKeybind();
    this.addServiceTrigger();
    this.loadSquance();
  }

  private loadSquance() {
    if(this.componentLoaded) {
      return;
    }

    this.loadPinnedItems();

    this.search$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe( (text) => {
      this.search(text);
    });

    this.componentLoaded = true;
  }

  ngOnDestroy() {
    if (!this.search$.closed) {
      this.search$.unsubscribe();
    }
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  textChanged(target: EventTarget | null) {
    if(!target) { return; }
    const value = (target as HTMLInputElement).value;
    if(this.dialogOpen) {
      this.search$.next(value);
    }
  }

  private search(text: string) {
    if(this.isProcessing) {
      return; 
    }
    if(!text) {
      this.datas = [];
      return;
    }
    this.isProcessing = true;

    this.searchService
    .search(text, this.settings.filters)
    .subscribe({
      next: (res) => {
         const files = (res?.patientFiles ?? []).map((x: any) => ({
    ...x,
    type: 'patientFiles' as const, // ✅ normalize
  }));

        this.datas = [
          ...(res?.cases ?? []),
          ...(res?.appointments ?? []),
          ...(res?.organizations ?? []),
          ...files,
        ];
      },
      error: () => {
        // Gerekirse error toast koy
      },
      complete: () => {
        this.isProcessing = false;
      }
    });
  }

  private loadPinnedItems() {
    const storage = localStorage.getItem('search_spinned_items');
    if(storage) {
      this.pinnedItems = JSON.parse(storage) as CoreSearchData[];

    } else {
      localStorage.setItem('search_spinned_items', JSON.stringify(this.pinnedItems));

    }
  }

  private addCustomSearchKeybind() {
    window.onkeyup = (e) => {
      if(e.key === 'F4') {
        this.triggerSearch();
      }
    }
  }

  private addServiceTrigger() {
    this.searchSubscription = this.searchService.searchTrigger$.subscribe(() => {
      this.triggerSearch();
    });
  }

  private triggerSearch() {
    this.loadSquance();
    if (this.dialogOpen) {
      this.closeDialog();
    } else {
      this.openDialog();
    }
  }

  openDialog() {
    if (this.searchBar && this.configPanel?.outoFocus) {
      this.searchBar.nativeElement.focus();
    }

    this.configPanel?.hide();
    this.dialogOpen = true;
    if (this.settings.openFavorites) {
      this.pinnedOpen = true;
    }
  }

  closeDialog() {
    this.pinnedOpen = false;
    this.searchText = '';
    this.datas = [];
    this.openConfig = false;
    this.configPanel?.hide();
    this.dialogOpen = false;
  }

  //  Pin Operations
  pinItem(item: CoreSearchData, index: number) {
    if(this.pinnedItems.length >= this.configPanel.fixLimit) {
      this.mesage.errorToast('Sabitleme Sınırına Ulaşıldı', `En fazla ${this.configPanel.fixLimit} adet ögenin sabitlenmesine izin veriliyor. Bu limitin üstünde öge sabitlenemez.`);
      return;
    }
    this.pinnedItems.push(item);
    this.datas.splice(index, 1);
    localStorage.setItem('search_spinned_items', JSON.stringify(this.pinnedItems));
  }

  unpinItem(index: number) {
    this.pinnedItems.splice(index, 1);
    localStorage.setItem('search_spinned_items', JSON.stringify(this.pinnedItems));
  }

  toggleConfigPanel(event: MouseEvent) {
    this.configPanel.toggle(event);
  }

  togglePinnedPanel() {
    this.pinnedOpen = !this.pinnedOpen;
  }
  //  ----------------
}
